<template>
    <div>
        <ErrorLogShower />
        <Progressbar processType="BnT" :currentStepIndex="3" v-if="!IsOrderOnOffer" />

        <div class="contentblock">
            <section class="contentblock__content">
                <div class="shop__fieldgroup shop__fieldgroup--no-separator">
                    <div class="migrol-rt-content" v-html="SuccessMessage"></div>

                    <div v-if="showPostOrderDataForm">
                        <div v-if="!postOrderDataSent">
                            <hr style="margin-bottom: 3rem;" />
                            <p class="shop__address-block-spacer-small">{{Strings['Shop.PostOrder.TitleDiesel']}}</p>
                            <ValidationObserver v-slot="{ handleSubmit }" slim>
                                <div class="migrol-form__address">
                                    <div class="migrol-form__address-row">
                                        <InputWithLabel :label="Strings['Shop.LabelNumberOfTanks']"
                                                        type="number"
                                                        v-model="numTanks"
                                                        cssclass="migrol-form__input-wrapper--medium"
                                                        rules="integer|min_value:0" />
                                    </div>
                                    <div class="migrol-form__address-row">
                                        <InputWithLabel :label="Strings['Shop.LabelSingleTankSize']"
                                                        type="number"
                                                        v-model="tankSize"
                                                        :postfix="Strings['Shop.UnitsLiter']"
                                                        cssclass="migrol-form__input-wrapper--medium"
                                                        rules="integer|min_value:0" />
                                    </div>
                                    <div class="migrol-form__address-row">
                                        <DatePickerWithLabel :label="Strings['Shop.PostOrder.LastTankrevision']"
                                                             v-model="lastTankRevision"
                                                             cssclass="migrol-form__input-wrapper--medium"
                                                             :rules="{ regex: /^((?:19|20)\d{2})-(1[012]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])$/ }" />
                                    </div>
                                    <div class="shop__address-block-spacer-small"></div>
                                    <div class="shop__error-message-block" v-if="postOrderDataSaveError">
                                        <ul>
                                            <li>{{Strings['Shop.Errors.GenericError']}}</li>
                                        </ul>
                                    </div>
                                    <div class="migrol-form__buttons">
                                        <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Shop.PostOrder.ButtonSend']" cssclass="migrol-form__button--green" @buttonClick="handleSubmit(submitForm)" />
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                        <div v-if="postOrderDataSent">
                            {{Strings['Shop.PostOrder.Thanks']}}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import $ from 'jQuery'
    import { ValidationObserver } from 'VeeValidate'
    import ErrorLogShower from '../_common/ErrorLogShower'
    import Transaction from '@/models/Transaction'
    import Progressbar from '../_common/Progressbar'
    import { PostOrderDataOutcomes } from '@/utils/constants';

    export default {
        data() {
            return {
                numTanks: '',
                tankSize: '',
                lastTankRevision: '',
                postOrderDataSent: false,
                postOrderDataSaveError: false
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'SuccessMessage',
                'OrderNrs',
                'OrderAuftraggeberNr'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),
            localData: {
                get() {
                    return {
                        "numTanks": this.numTanks,
                        "tankSize": this.tankSize,
                        "lastTankRevision": this.lastTankRevision
                    }
                }
            },
            CurrentTransaction() {
                return Transaction.query().with(['positions.warenempfaenger', 'material', 'deliveryPeriod']).first();
            },
            showPostOrderDataForm() {
                return this.CurrentTransaction.positions.length == 1;
            },
            IsOrderOnOffer() {
                return this.CurrentTransaction.offerId !== null;
            }
        },
        methods: {
            submitForm() {
                let formData = { ...this.$store.getters['orderResultInfo'], ...this.localData };
                var vm = this;
                vm.$store.commit('increasePendingAjaxCalls');
                vm.postOrderDataSaveError = false;
                $.post('/migrolapi/' + window.CONFIG.language + '/shop/UpdatePostOrderDataHeizoel', formData)
                    .done((response) => {
                        if (response.Outcome == PostOrderDataOutcomes.Saved) {
                            this.postOrderDataSent = true;
                        } else {
                            vm.manageError();
                        }
                    })
                    .fail(() => {
                        vm.manageError();
                    })
                    .always(function () {
                        vm.$store.commit('decreasePendingAjaxCalls');
                    });
            },
            manageError() {
                this.postOrderDataSaveError = true;
            }
        },
        mounted() {
            if (window.dataLayer) {

                //if at least one position has the fill option set, we have to add a checkoutOption
                if (this.CurrentTransaction.positions.reduce(function (fillOptionSet, pos) { return fillOptionSet || pos.wantsFillOption; }, false)) {
                    window.dataLayer.push({
                        'event': 'checkoutOption',
                        'ecommerce': {
                            'checkout_option': {
                                'actionField': { 'step': 3, 'option': 'tank fuellen' }
                            }
                        }
                    });
                }

                window.dataLayer.push({
                    event: 'purchase',
                    shipping_tier: this.CurrentTransaction.deliveryPeriod.displayText,
                    quantity: this.CurrentTransaction.totalAmount,
                    zip: this.CurrentTransaction.positions[0].warenempfaenger.zipcode.toString(),
                    ecommerce: {
                        currency: 'CHF',
                        value: this.CurrentTransaction.material.getTotalPrice(null), // Umsatzgesamt - Brutto
                        transaction_id: this.OrderNrs != null ? this.OrderNrs.join(',') : null, // Eindeutige TransactionID
                        coupon: this.CurrentTransaction.discountCode, // - Optional - Hier Coupon Code aus dem Checkout hinzuf�gen
                        transaction_type: 'bestellung', // z.B.: bestellung oder offerte
                        client_number: this.OrderAuftraggeberNr,
                        items: [{
                            item_name: 'Diesel', // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                            item_id: this.CurrentTransaction.material.material, // �bergeordnete ID f�r Heiz�l, Holzpellets, Diesel da Variante des Produktes noch nicht vorhanden - wenn nicht vorhanden leer
                            price: parseFloat((this.CurrentTransaction.material.getUnitPrice(null) / 100).toFixed(4)), // Preis per Liter
                            item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                            item_category: 'diesel', // z.B.: Heiz�l, Holzpellets, Diesel
                            item_variant: this.CurrentTransaction.material.name, // Produktvariant, wenn vorhanden (zB.: gelb) Varaint der Produkte erst im Checkout Steps ausw�hlbar - Bitte leer lassen
                            quantity: this.CurrentTransaction.totalAmount // Menge
                        }]
                    }
                });
            }
        },
        components: {
            ValidationObserver,
            ErrorLogShower,
            Progressbar
        }
    };
</script>